import React, { useEffect, useState } from 'react';
import './Sidebar.css';
import { FaBars } from 'react-icons/fa';

export const Sidebar = ({ setSelectedMenu }) => {
    const [userInfo, setUserInfo] = useState(null);
    const [orgCode, setOrgCode] = useState(null);
    const [activeMenu, setActiveMenu] = useState('food');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    useEffect(() => {
        const storedUserInfo = localStorage.getItem("user");
        if (storedUserInfo) {
            const parsedUserInfo = JSON.parse(storedUserInfo);
            setUserInfo(parsedUserInfo);
            setOrgCode(parsedUserInfo?.organizationInfo?.orgCode || null);
        }
    }, []);

    const handleMenuClick = (menu) => {
        setSelectedMenu(menu);
        setActiveMenu(menu);
        setIsSidebarOpen(false); // Auto-close sidebar when clicking a menu item
    };

    const toggleSidebar = (event) => {
        event.stopPropagation(); // Prevent sidebar from immediately closing
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                isSidebarOpen &&
                !event.target.closest('.organization-pos-sidebar') &&
                !event.target.closest('.menu-icon')
            ) {
                setIsSidebarOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [isSidebarOpen]);
    

    return (
        <div>
            {/* Mobile menu icon */}
            <div className="d-lg-none p-3">
                <FaBars onClick={toggleSidebar} className="cursor-pointer menu-icon" size={30} />
            </div>

            {/* Sidebar */}
            <div className={`organization-pos-sidebar shadow-lg h-100 bg-white position-fixed top-0 left-0 py-4 ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed d-lg-flex'}`}>
                <div>
                    <h4 className="m-0 p-0">{userInfo?.organizationInfo?.name}</h4>
                </div>
                <ul className='p-0 d-flex gap-3 flex-column m-0'>
                    <li 
                        className={`list-unstyled d-flex gap-1 p-2 cursor-pointer rounded fs-6 fw-bold ${activeMenu === 'food' ? 'bg-primary text-white' : ''}`}
                        onClick={() => handleMenuClick('food')}
                    >
                      <i class="ri-dashboard-line fs-6"></i>  Overview
                    </li>
                    <li 
                        className={`list-unstyled d-flex gap-1 p-2  cursor-pointer rounded fs-6 fw-bold ${activeMenu === 'order' ? 'bg-primary text-white' : ''}`}
                        onClick={() => handleMenuClick('order')}
                    >
                      <i class="ri-restaurant-line fs-6"></i>  Order
                    </li>
                    <li 
                        className={`list-unstyled d-flex gap-1 p-2 cursor-pointer rounded fs-6 fw-bold ${activeMenu === 'bill' ? 'bg-primary text-white' : ''}`}
                        onClick={() => handleMenuClick('bill')}
                    >
                      <i class="ri-bill-line fs-6"></i>  Bill
                    </li>
                    <li 
                        className={`list-unstyled d-flex gap-1 p-2 cursor-pointer rounded fs-6 fw-bold ${activeMenu === 'customer' ? 'bg-primary text-white' : ''}`}
                        onClick={() => handleMenuClick('customer')}
                    >
                      <i class="ri-user-line"></i>  Customer
                    </li>
                </ul>
            </div>
        </div>
    );
};
